import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, unref as _unref, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5932257d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "userlist-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "User List", -1))
const _hoisted_3 = { class: "search-bar" }
const _hoisted_4 = { class: "table-container" }
const _hoisted_5 = { class: "styled-table" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "S.No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Date of Joining"),
    /*#__PURE__*/_createElementVNode("th", null, "Actions")
  ])
], -1))
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "no-users-message"
}, "No Users in this category.", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "pagination-controls" }
const _hoisted_14 = { class: "pagination" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 1,
  class: "loading-container"
}

import DateTimeBadge from '@/components/DateTimeBadge.vue';
import { ref, computed, onMounted } from 'vue';
import { useUserStore } from '@/stores/UserStore';
import { useEmployeeStore } from '@/stores/UserEmployee';
import { deleteFromUrl } from '@/api/api';
import { useRouter } from 'vue-router';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserListView',
  setup(__props) {

const userStore = useUserStore();
const employeeStore = useEmployeeStore();
const router = useRouter();

const usersLoaded = ref(false);
const searchQuery = ref('');
const filterAllUsers = ref(true);
const filterAdmin = ref(false);
const filterManager = ref(false)
const filterEmployee = ref(false);
const pageSize = ref(10);
const currentPage = ref(1);
const userDetails = ref(null)


const calculateSerialNumber = (index) => {
  return (currentPage.value - 1) * pageSize.value + index + 1;
};

const setFilterAllUser = () => {
  filterAllUsers.value = true;
  filterAdmin.value = false;
  filterManager.value = false;
  filterEmployee.value = false;
}

const setFilterAdmins = () => {
  filterAllUsers.value = false;
  filterAdmin.value = true;
  filterManager.value = false;
  filterEmployee.value = false;
}

const setFilterManagers = () => {
  filterAllUsers.value = false;
  filterAdmin.value = false;
  filterManager.value = true;
  filterEmployee.value = false;
}

const setFilterEmployees = () => {
  filterAllUsers.value = false;
  filterAdmin.value = false;
  filterManager.value = false;
  filterEmployee.value = true;
}

const goToPage = (pageNumber) => {
  currentPage.value = pageNumber;
};

const goToPrevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const goToNextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const paginatedUsers = computed(() => {
  if (filteredUsers.value.length === 0) return [];
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return filteredUsers.value.slice(start, end);
});

const totalPages = computed(() => {
  return Math.ceil(filteredUsers.value.length / pageSize.value);
});

const viewUser = (userEmployeeId) => {
  router.push({ name: 'employeeDetail', params: { userEmployeeId } });
};

const filteredUsers = computed(() => {
  let userEmployees = employeeStore.employees;
  if (searchQuery.value) {
    userEmployees = userEmployees.filter(ue =>
      ue.user.full_name.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
      ue.user.email.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
  }
  // Filter by role using User data within each UserEmployee
  if (filterAdmin.value) {
    userEmployees = userEmployees.filter(ue => ue.user.is_superuser);
  } else if (filterManager.value) {
    userEmployees = userEmployees.filter(ue => ue.user.is_staff && !ue.user.is_superuser);
  } else if (filterEmployee.value) {
    userEmployees = userEmployees.filter(ue => (!ue.user.is_staff && !ue.user.is_superuser));
  }

  return userEmployees;
});


const deleteUser = async (userEmployee, index) => {
  if (confirm('Are you sure you want to delete this user?')) {
    try {
      const userEmployeeId = userEmployee.id;
      const userId = userEmployee.user.id;
      await deleteFromUrl(`/ops/api/users/${userEmployeeId}/`);
      await deleteFromUrl(`/ops/api/siteusers/${userId}/`);

      employeeStore.employees.splice(index, 1);
      employeeStore.employees.splice(index, 1);

      alert('User and UserEmployee successfully deleted.');
    } catch (error) {
      console.error('Error deleting user or user employee:', error);
      alert('Cannot delete user or user employee. There may be assigned tasks or other dependencies.');
    }
  }
};

const generateReportForUser = async (userEmployeeId) => {
  try {
    userDetails.value = await employeeStore.fetchEmployeeDetails(userEmployeeId);
    if (userDetails.value) {
      generatePDF(userDetails);
    } else {
      console.error('Error fetching user details');
    }
  } catch (error) {
    console.error('Error generating report:', error);
  }
};

function truncateMilliseconds(durationStr) {
  return durationStr.split('.')[0];
}

const dateOfGenerating = new Date().toISOString().split('T')[0];

const addFooter = async (doc) => {
  const footerStartY = 280; // Adjust as needed for positioning
  // Footer text content setup
  doc.setFontSize(10);
  doc.setTextColor(100);
  const imageUrl = '/static/img/mudbots-master-logo-lg.png';
  doc.addImage(imageUrl, 'PNG', 20, doc.internal.pageSize.height - 27, 40, 20);
  doc.setFont('helvetica', 'bold');
  doc.text('OFFICE HOURS', 70, footerStartY);
  doc.setFont('helvetica', 'normal');
  doc.text('09:00 - 05:00 MST\nMountain Standard Time', 70, footerStartY + 5);
  doc.setFont('helvetica', 'bold');
  doc.text('CALL US', 120, footerStartY);
  doc.setFont('helvetica', 'normal');
  doc.text('800-733-2302\nMonday - Friday', 120, footerStartY + 5);
  doc.setFont('helvetica', 'bold');
  doc.text('LOCATION', 170, footerStartY);
  doc.setFont('helvetica', 'normal');
  doc.text('40 Iron St\nUT 84074', 170, footerStartY + 5);
};

const generatePDF = (userDetails) => {
  // console.log('Generating PDF for:', employeeDetails.value);
  if (!userDetails.value) {
    alert("Please select a user and wait for data to load");
    return;
  }
  let serialNumber = 1;
  const tableData = userDetails.value.tasks.map(task => {
    return {
      serialNumber: serialNumber++,
      task: task.name,
      jobName: task.job_name,
      startDate: task.started ? new Date(task.started).toLocaleDateString() : "N/A",
      endDate: task.concluded ? new Date(task.concluded).toLocaleDateString() : "N/A",
      workCenter: task.work_center?.name || "N/A",
      costCenter: task.cost_center?.name || "N/A",
      totalHours: truncateMilliseconds(task.total_active_duration) || "0",
      laborCost: task.labor_cost || "0",
    };
  });

  const doc = new jsPDF();
  doc.setFontSize(20);
  doc.text('User Report', 20, 20);
  const pageWidth = doc.internal.pageSize.getWidth();
  const imageWidth = 30;
  const topMargin = 18;

  const addTopRightCornerImage = async () => {
    const imageUrl = '/static/img/userprofile.png';
    const rightXCoordinate = pageWidth - imageWidth - 15;
    await doc.addImage(imageUrl, 'PNG', rightXCoordinate, topMargin, imageWidth, 30);
  };

  addTopRightCornerImage();

  const userDataStartY = 30;
  // Set font to bold for labels and normal for values
  doc.setFontSize(12);
  // Name label and value
  doc.setFont('helvetica', 'bold');
  doc.text('Name:', 20, userDataStartY);
  doc.setFont('helvetica', 'normal');
  doc.text(`${userDetails.value.user.full_name}`, 38, userDataStartY);
  // Email label and value
  doc.setFont('helvetica', 'bold');
  doc.text('Email:', 20, userDataStartY + 6);
  doc.setFont('helvetica', 'normal');
  doc.text(`${userDetails.value.user.email}`, 38, userDataStartY + 6);
  // Hourly Pay label and value
  doc.setFont('helvetica', 'bold');
  doc.text('Hourly Pay $ :', 20, userDataStartY + 12);
  doc.setFont('helvetica', 'normal');
  doc.text(`${userDetails.value.hourly_pay}`, 50, userDataStartY + 12);
  // Joined Date label and value
  doc.setFont('helvetica', 'bold');
  doc.text('Joined Date:', 20, userDataStartY + 18);
  doc.setFont('helvetica', 'normal');
  const dateOfJoining = new Date(userDetails.value.user.date_joined);
  const formattedDateOfJoining = `${dateOfJoining.getFullYear()}-${(dateOfJoining.getMonth() + 1).toString().padStart(2, '0')}-${dateOfJoining.getDate().toString().padStart(2, '0')}`;
  doc.text(formattedDateOfJoining, 50, userDataStartY + 18);

  const tableColumn = [
    { header: "S.No", dataKey: "serialNumber" },
    { header: "Task", dataKey: "task" },
    { header: "Job Name", dataKey: "jobName" },
    { header: "Start Date (MM/DD/YY)", dataKey: "startDate" },
    { header: "End Date (MM/DD/YY)", dataKey: "endDate" },
    { header: "Work Center", dataKey: "workCenter" },
    { header: "Cost Center", dataKey: "costCenter" },
    { header: "Total Hours", dataKey: "totalHours" },
    { header: "Labor Cost", dataKey: "laborCost" },
  ];

  const mapTasksToTableData = (tasks) => tasks.map((task, index) => {
    return {
      serialNumber: index + 1,
      task: task.name,
      jobName: task.job_name,
      startDate: task.started ? new Date(task.started).toLocaleDateString() : "N/A",
      endDate: task.concluded ? new Date(task.concluded).toLocaleDateString() : "N/A",
      workCenter: task.work_center?.name || "N/A",
      costCenter: task.cost_center?.name || "N/A",
      totalHours: truncateMilliseconds(task.total_active_duration) || "0",
      laborCost: task.labor_cost || "0",
    };
  });

  const completedTasks = userDetails.value.tasks.filter(task => task.started && task.concluded);
  const activeTasks = userDetails.value.tasks.filter(task => task.started && !task.concluded);
  const notStartedTasks = userDetails.value.tasks.filter(task => !task.started);

  const categories = [
    { title: 'Completed Tasks', tasks: completedTasks },
    { title: 'Active Tasks', tasks: activeTasks },
    { title: 'Not Started Tasks', tasks: notStartedTasks },
  ];

  let startY = userDataStartY + 37;
  categories.forEach((category, index) => {
    if (category.tasks.length > 0) {
      doc.setFontSize(16);
      doc.text(category.title, 20, startY);
      startY += 6

      const tableData = mapTasksToTableData(category.tasks, index * 1000);
      doc.autoTable({
        columns: tableColumn,
        body: tableData,
        startY: startY,
        theme: 'striped',
        headStyles: { fillColor: [75, 82, 219] },
        styles: { fontSize: 10, cellPadding: 3, overflow: 'linebreak' },
        margin: { bottom: 30 },
      });
      startY = doc.lastAutoTable.finalY + 20
    }
  });
  doc.setPage(doc.internal.getNumberOfPages());
  addFooter(doc);
  const fileName = `Report ${userDetails.value.user.full_name} ${dateOfGenerating}.pdf`;
  doc.save(fileName);
};

onMounted(async () => {
  try {
    await userStore.fetchAllUsers();
    await employeeStore.fetch();
    usersLoaded.value = true
  } catch (error) {
    console.error('Error loading users:', error);
  }
});


return (_ctx: any,_cache: any) => {
  return (usersLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", { class: "filtering-buttons" }, [
          _createElementVNode("button", {
            type: "button",
            class: "apple-button show-all",
            onClick: setFilterAllUser
          }, "Show All"),
          _createElementVNode("button", {
            type: "button",
            class: "apple-button user",
            onClick: setFilterAdmins
          }, "Admins"),
          _createElementVNode("button", {
            type: "button",
            class: "apple-button user",
            onClick: setFilterManagers
          }, "Managers"),
          _createElementVNode("button", {
            type: "button",
            class: "apple-button useremployee",
            onClick: setFilterEmployees
          }, "Employees")
        ]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            placeholder: "Search user...",
            class: "search-input"
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (paginatedUsers.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(paginatedUsers.value, (userEmployee, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: userEmployee.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(calculateSerialNumber(index)), 1),
                      _createElementVNode("td", null, _toDisplayString(userEmployee.user.full_name), 1),
                      _createElementVNode("td", null, _toDisplayString(userEmployee.user.email), 1),
                      _createElementVNode("td", null, [
                        _createVNode(DateTimeBadge, {
                          time: userEmployee.user?.date_joined
                        }, null, 8, ["time"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "apple-button view-button",
                          onClick: ($event: any) => (viewUser(userEmployee.id))
                        }, "View", 8, _hoisted_7),
                        (_unref(employeeStore).currentUser.user?.is_superuser)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "apple-button delete-button",
                              onClick: ($event: any) => (deleteUser(userEmployee, index))
                            }, "Delete", 8, _hoisted_8))
                          : _createCommentVNode("", true),
                        (_unref(employeeStore).currentUser.user?.is_superuser)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "apple-button report-button",
                              onClick: ($event: any) => (generateReportForUser(userEmployee.id))
                            }, "Generate Report", 8, _hoisted_9))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                : (_openBlock(), _createElementBlock("tr", _hoisted_10, _hoisted_12))
            ])
          ]),
          _createElementVNode("nav", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
              }, [
                _createElementVNode("button", {
                  class: "page-link",
                  onClick: goToPrevPage,
                  disabled: currentPage.value === 1
                }, "Previous", 8, _hoisted_15)
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: _normalizeClass(["page-item", { active: currentPage.value === page }]),
                  key: page
                }, [
                  _createElementVNode("button", {
                    class: "page-link",
                    onClick: ($event: any) => (goToPage(page))
                  }, _toDisplayString(page), 9, _hoisted_16)
                ], 2))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
              }, [
                _createElementVNode("button", {
                  class: "page-link",
                  onClick: goToNextPage,
                  disabled: currentPage.value === totalPages.value
                }, "Next", 8, _hoisted_17)
              ], 2)
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_18))
}
}

})